
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Créez une adresse mail professionnelle avec votre nom de domaine",
    description:
      "Renforcez votre image avec un mail pro en créant une adresse mail liée à votre nom de domaine. Suivez ce tutoriel pour une mise en place simple et rapide.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
